import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import workflowRunAbandoned, {
	type WorkflowRunAbandonedAction,
} from '@Application/WorkflowRuns/WorkflowRun/Actions/workflowRunAbandoned';
import workflowRunAbandonmentFailed, {
	type WorkflowRunAbandonmentFailedAction,
} from '@Application/WorkflowRuns/WorkflowRun/Actions/workflowRunAbandonmentFailed';
import type AbandonWorkflowRun from '@Application/WorkflowRuns/WorkflowRun/Commands/AbandonWorkflowRun';
import { del } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = WorkflowRunAbandonedAction | WorkflowRunAbandonmentFailedAction;

/** `204`. */
export default (command: AbandonWorkflowRun) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			await del<void>(
				`${buildSubjectApiPath(command.facilityId, command.subject)}/workflow-runs/${command.runId}`,
			);

			const action = workflowRunAbandoned(
				{ runId: command.runId },
				command.facilityId,
				command.subject.typeKey,
				command.subject.subjectId,
			);
			dispatch(action);
			return action;
		} catch (error) {
			const action = workflowRunAbandonmentFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
